import { API_URL_AUTH, API_URL_STORE } from "./urls"

const login = async (credentials) =>
  window.axios
    .post(API_URL_AUTH + "login", {
      version: "1.0.0",
      requestBodyDto: {
        userLogin: credentials.userLogin,
        userPass: credentials.userPass,
      },
    })
    .then(({ data }) => {
      if (data.responseCode === "OC_OK" || data.code === "OC_OK") {
        const user = {
          ...(data.responseEntity || data.createdEntity),
          userLogin: credentials.userLogin,
        }

        return user
      }

      throw new Error(data.message)
    })
    .catch((error) => {
      throw error
    })

const refreshJwt = async (expiredTokens, userLogin, refreshToken) => {
  if (window.MobileApp) {
    const credentialsData = window.MobileApp.getAuthData()
    const credentials = JSON.parse(credentialsData)

    return login(credentials)
  }

  return window.axios
    .post(
      API_URL_AUTH + "jwt/refresh",
      {
        version: "1.0.0",
        requestBodyDto: {
          expiredJwt: expiredTokens.expiredJwt,
          refreshJwt: expiredTokens.refreshJwt,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
        },
      },
    )
    .then(({ data }) => {
      if (data.responseCode === "OC_OK" || data.code === "OC_OK") {
        const user = { ...(data.responseEntity || data.createdEntity), userLogin }

        return user
      }

      throw new Error(data.message)
    })
    .catch((error) => {
      throw error
    })
}

const getUserDetailsApi = () =>
  window.axios
    .get(API_URL_STORE + "user-v1/current/v1/get")
    .then(({ data }) => {
      if (data.code === "OC_OK") {
        return data.createdEntity
      }

      throw new Error(data.message)
    })
    .catch((error) => {
      throw error
    })

export { login, refreshJwt, getUserDetailsApi }
